import { css, SerializedStyles } from '@emotion/core'
import React from 'react'

import { breakpoints } from '../../constants/breakPoints'
import { baseFontSize } from '../Layout'

interface Props {
  className?: string
  children?: React.ReactNode
  cssStyles?: SerializedStyles
}

const RichText: React.FunctionComponent<Props> = ({ className, children, cssStyles }) => {
  return (
    <div css={[containerStyle, cssStyles]} className={`${className} rich-text stashing-block`}>
      {children}
    </div>
  )
}

export default RichText

const containerStyle = css`
  max-width: 800px;
  margin: 0 auto;

  ol li::before {
    content: counter(list-item) '.';
    top: 0.318rem;

    @media screen and (max-width: ${breakpoints.small}px) {
      left: -1.75rem !important;
      width: 1.5rem;
      text-align: right;
    }
  }

  ol li:has(h3)::before {
    top: 0.325rem;

    @media screen and (max-width: ${breakpoints.small}px) {
      top: 0.3rem;
    }
  }

  ul {
    margin-block-start: 1rem;
    margin-block-end: 2rem;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 2rem;

    li::before {
      content: '•';
      font-size: 1.25rem;

      @media screen and (max-width: ${breakpoints.small}px) {
        left: -1rem !important;
      }
    }
  }

  ol,
  ul {
    list-style-type: none;

    li {
      position: relative;
      margin-bottom: 0;
      font-weight: 800;

      &::before {
        position: absolute;
        color: #318eff;

        @media screen and (min-width: ${breakpoints.small + 1}px) {
          width: 2rem;
          left: -2.1rem !important;
          text-align: right;
        }
      }

      &:has(h3)::before {
        @media screen and (min-width: ${breakpoints.small + 1}px) {
          left: -2.34rem !important;
        }
      }
    }

    .paragraph {
      margin-bottom: 1rem;
      margin-left: 0.25rem;
    }
  }

  ol li .paragraph {
    transform: translateY(1px);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  & > div {
    &:first-of-type {
      margin-top: 0;
    }
    &:last-child {
      margin-top: 0;
    }
  }

  .heading1,
  .heading2,
  .heading3 {
    display: inline-block;
    width: 100%;
    font-weight: bold !important;
    font-family:
      'Eina 01',
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      Oxygen-Sans,
      Ubuntu,
      Cantarell,
      'Helvetica Neue',
      sans-serif;
  }

  .heading1 {
    font-size: ${(35 / baseFontSize).toFixed(3)}rem !important;
    line-height: ${(42 / baseFontSize).toFixed(3)}rem !important;
    margin: ${(48 / baseFontSize).toFixed(3)}rem 0 ${(24 / baseFontSize).toFixed(3)}rem;
  }

  .heading2 {
    font-size: ${(30 / baseFontSize).toFixed(3)}rem !important;
    line-height: ${(40 / baseFontSize).toFixed(3)}rem !important;
    margin: ${(32 / baseFontSize).toFixed(3)}rem 0 ${(16 / baseFontSize).toFixed(3)}rem;
  }

  .heading3 {
    font-size: ${(22 / baseFontSize).toFixed(3)}rem !important;
    line-height: ${(30 / baseFontSize).toFixed(3)}rem !important;
    margin: ${(12 / baseFontSize).toFixed(3)}rem 0 ${(12 / baseFontSize).toFixed(3)}rem;
  }

  .paragraph,
  .strong-paragraph {
    font-size: ${(18 / baseFontSize).toFixed(3)}rem !important;
    line-height: ${(32 / baseFontSize).toFixed(3)}rem !important;
    margin: 0;
    margin-bottom: ${(24 / baseFontSize).toFixed(3)}rem;
  }

  .paragraph {
    font-weight: 400;
  }

  .strong-paragraph {
    font-weight: 600;
  }

  .footnote {
    font-size: ${(12 / baseFontSize).toFixed(3)}rem !important;
  }

  .caption {
    color: #000;
    text-align: center;
    font-size: ${(14 / baseFontSize).toFixed(3)}rem !important;
    line-height: ${(27 / baseFontSize).toFixed(3)}rem !important;
    margin: ${(12 / baseFontSize).toFixed(3)}rem 0 ${(32 / baseFontSize).toFixed(3)}rem;
  }
`
